export enum PulseOrderType {
  None = 'none',
  Now = 'now',
  Future = 'future',
  Any = 'any',
}
